import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useDayjs } from '@shared/lib/format'

import { useTutorKanbanStore } from './store'
import { isTutorKanbanExitStage } from '../config/tutor-kanban-exit-stage.const'

interface TutorKanbanPickerFinalDayReturn {
  isVisible: ComputedRef<boolean>
  refDate: ComputedRef<string | null>
  refMinDate: ComputedRef<Date>
  setChange: (date: string | null) => void
}

export const useTutorKanbanPickerFinalDay = (): TutorKanbanPickerFinalDayReturn => {
  const tutorKanbanStore = useTutorKanbanStore()
  const dayjs = useDayjs()

  const isVisible = computed<boolean>(() => isTutorKanbanExitStage(tutorKanbanStore.getStage))

  const refDate = computed<string | null>(() => tutorKanbanStore.getExitDate)

  const refMinDate = computed<Date>(() => {
    const timezone = tutorKanbanStore.getTimezone
    const tutorToday = (timezone ? dayjs().tz(timezone) : dayjs()).format(DateFormat.DefaultDate)

    return dayjs(tutorToday).toDate()
  })

  const setChange = (date: string | null): void => {
    const value = date && dayjs(date).isValid() ? date : null

    tutorKanbanStore.setTutorExitDate(value)
  }

  return {
    isVisible,
    refDate,
    refMinDate,
    setChange,
  }
}
